import {announce} from '@github-ui/aria-live'
import {remoteForm} from '@github/remote-form'

remoteForm('.js-form-toggle-target', async function (form, wants) {
  try {
    await wants.text()
  } catch {
    return
  }

  const container = form.closest<HTMLElement>('.js-form-toggle-container')!
  const button = container.querySelector<HTMLElement>('.js-form-toggle-target[hidden]')
  button!.hidden = false
  form.hidden = true
  const feedback = form.getAttribute('data-sr-feedback') || ''
  feedback && announce(feedback)
  button?.querySelector<HTMLInputElement>('input[type=submit], button[type=submit]')?.focus()
})
